module.exports = __webpack_public_path__ + "img/add.eae3cba9.svg";